var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status",class:_vm.getStatus},[(_vm.intake?.status === 'rejected')?_c('v-icon',{attrs:{"color":"white"}},[_vm._v("mdi-close")]):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }